import React from 'react';

import { Box, Tooltip } from '@mui/material';
import { JBColors, JBIcon } from '@bjb-gcrm/gcrm-frontend-components';

type Props = {
  tooltipText: string;
};
export const MultiTabWarning = ({ tooltipText }: Props) => {
  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <Box mr={1}>
        <JBIcon
          iconName="conditional"
          fill={JBColors.support.orange[120]}
          size="xl"
          dataTestId="multi-tabs-warning-icon"
        />
      </Box>
    </Tooltip>
  );
};
